import { ShopifyProductLink } from "@/types/shopify.ts";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@components/ui/alert-dialog.tsx";
import { Button } from "@components/ui/button.tsx";
import { AlertDialogProps } from "@radix-ui/react-alert-dialog";

type ConfirmUnlinkProductAlertDialogProps = AlertDialogProps & {
  productLink: ShopifyProductLink;
  onConfirm: () => void;
};

export default function ConfirmUnlinkProductAlertDialog({
  productLink: { product },
  onConfirm,
  ...props
}: ConfirmUnlinkProductAlertDialogProps) {
  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Dé-associer les produits ?</AlertDialogTitle>
          <AlertDialogDescription>
            Le produit{" "}
            <span className="whitespace-nowrap text-slate-950">
              {product.title}
            </span>{" "}
            ne sera plus configurable par les clients dans la boutique.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>

          <AlertDialogAction asChild>
            <Button variant="destructive" size="sm" onClick={onConfirm}>
              Confirmer
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
